import { RootState } from '..';
import { IData } from './types';

export const seminarHaveParticipantsSelector = (state: RootState): IData =>
  state.participant.data;
